module.exports = __webpack_public_path__ + "static/media/game_icon_archero2.e5f01777.png";